import EntityBaseRepository from '@/api/misc/EntityBaseRepository';
import { AxiosResponse } from 'axios';

export default class ApplicationRepository extends EntityBaseRepository {

    public loadTheme(themeToken: string): Promise<AxiosResponse> {
        const urlencoded = new URLSearchParams();
        urlencoded.append('f', 'getSwrTheming');
        urlencoded.append('json', JSON.stringify({ theme_token: themeToken }));
        return this.axiosClient.post(this.endpointDefault, urlencoded);
    }

}
